<template>
    <section class="your-valuation" id="your-valuation">
        <StepBar />
        <div class="manual-valuation__hero-container">
            <div class="manual-valuation__bg"></div>
        </div>
        <div class="manual-valuation__container">
            <img src="/images/valuation-tool/not-my-vehicle/expired-basket-icon@2x.svg" alt="" class="manual-valuation__icon" />
            <p class="manual-valuation__text">Thank you for your details. We have sent the valuation information onto our customer hub team who will look into this further</p>
            <a @click="newValuation()" class="btn btn--primary card__button">
                <span class="">Start new valuation</span>
            </a>
        </div>
    </section>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import StepBar from "../Sections/StepBar";


export default {
    components: {
        StepBar,
    },
    methods: {
        ...mapActions("ValuationTool", ["newValuation", "goToPosition"]),
    },
    computed: {
        ...mapState("Auth", ['authenticated']),
        ...mapGetters('CustomerData', ['customerData']),
    },
    mounted() {
        this.goToPosition('valuation-start')
        if (this.authenticated === true) {
            const userName = this.customerData.firstName;
            const myAccountSpan = document.getElementById('header-menu__my-account');
            if (myAccountSpan) {
                myAccountSpan.textContent = userName;
            }
        }
    }
}
</script>